/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Command } from './Command';
import {
    CommandFromJSON,
    CommandFromJSONTyped,
    CommandToJSON,
} from './Command';
import type { Value } from './Value';
import {
    ValueFromJSON,
    ValueFromJSONTyped,
    ValueToJSON,
} from './Value';

/**
 * New empty row, added when the user presses the plus (+) button (edit only, for canAddRows = true)
 * @export
 * @interface Row
 */
export interface Row {
    /**
     * 
     * @type {string}
     * @memberof Row
     */
    id?: string;
    /**
     * Usually empty because the +/- buttons are shown in first cell
     * @type {string}
     * @memberof Row
     */
    label?: string;
    /**
     * 
     * @type {Array<Value>}
     * @memberof Row
     */
    values: Array<Value>;
    /**
     * 
     * @type {Command}
     * @memberof Row
     */
    editCommand?: Command;
    /**
     * Whether the row is removable (on edit page or wizard only)
     * @type {boolean}
     * @memberof Row
     */
    removable?: boolean;
    /**
     * The not removable description, in case the row isn't removable (on edit page or wizard only)
     * @type {string}
     * @memberof Row
     */
    notRemovableDescription?: string;
    /**
     * Whether the row is editable (on edit page or wizard only)
     * @type {boolean}
     * @memberof Row
     */
    editable?: boolean;
    /**
     * The not editable description, in case the row is read-only (on edit page or wizard only)
     * @type {string}
     * @memberof Row
     */
    notEditableDescription?: string;
}

/**
 * Check if a given object implements the Row interface.
 */
export function instanceOfRow(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "values" in value;

    return isInstance;
}

export function RowFromJSON(json: any): Row {
    return RowFromJSONTyped(json, false);
}

export function RowFromJSONTyped(json: any, ignoreDiscriminator: boolean): Row {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'label': !exists(json, 'label') ? undefined : json['label'],
        'values': ((json['values'] as Array<any>).map(ValueFromJSON)),
        'editCommand': !exists(json, 'editCommand') ? undefined : CommandFromJSON(json['editCommand']),
        'removable': !exists(json, 'removable') ? undefined : json['removable'],
        'notRemovableDescription': !exists(json, 'notRemovableDescription') ? undefined : json['notRemovableDescription'],
        'editable': !exists(json, 'editable') ? undefined : json['editable'],
        'notEditableDescription': !exists(json, 'notEditableDescription') ? undefined : json['notEditableDescription'],
    };
}

export function RowToJSON(value?: Row | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'label': value.label,
        'values': ((value.values as Array<any>).map(ValueToJSON)),
        'editCommand': CommandToJSON(value.editCommand),
        'removable': value.removable,
        'notRemovableDescription': value.notRemovableDescription,
        'editable': value.editable,
        'notEditableDescription': value.notEditableDescription,
    };
}

